import React, { Component } from 'react';
import Sidebar from '../../common/Sidebar';
import Topbar from '../../common/Topbar';
import CompanyTabs from './topmenu';
import * as Constants from '../../common/Global/constants';
import ListCompanies from './listcompanies';
import ListUnits from './listunits';
import Employees from './listemployees';
import Grouping from './unitgrouping';
import ListCities from '../CityMaster/listCities';
import ListStates from '../CityMaster/listStates';
import ListCountries from '../CityMaster/listCountries';
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import { isEmptyVariable,getThemeSettingsVariables, 
    getLocalStorageVariables, 
    handleTokenExpiry} from '../../common/Global/commonFunctions';
import ListProjects from './listprojects';
let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();
class ClientsMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedAuditTypes:[],
            companyId:"",
            companyType:"",
            showCityMaster:false,
            unitId:"",
            empHeaderText:"",
            displayingCompanies:true,
            displayingUnits:false,
            displayingProjects:false,
            displayingEmployees:false,
            displayCards:true,
            displayingGrouping:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false,
            showUnit: false,
            showProject:false,
            showEmployee:false,
            isShowProject:false
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
        this.initData();
    }

    // This function to handle click events on the Employees dropdown
    viewEmployeesDropDownItemClick = (unitId,empHeaderText) => {
        this.setState({
            unitId:unitId,
            showEmployee:true,
            showProject:false,
            empHeaderText:empHeaderText,
            displayingCompanies:false,
            displayingUnits:false,
            displayingProjects:false,
            displayingEmployees:true,
            displayingGrouping:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false
        })
    }

    // This function to handle click events on the View Units dropdown
    viewUnitsDropDownItemClick = (companyId) => {
        this.setState({
            unitId:"",
            companyId:companyId,
            companyType:this.state.companyType,
            showUnit: true,
            showEmployee:false,
            showProject:false,
            displayingCompanies:false,
            displayingUnits:true,
            displayingProjects:false,
            displayingEmployees:false,
            displayingGrouping:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false
        })
    }

    viewProjectsDropDownItemClick = (companyId) => {
        this.setState({
            companyId:companyId,
            showProject:true,
            showEmployee:false,
            displayingCompanies:false,
            displayingUnits:false,
            displayingProjects:true,
            displayingEmployees:false,
            displayingGrouping:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false
        })
    }

    // This function to handle click events on the Employees tab
    employeesTabItemOnClick = (unitId) => {
        this.setState({
            unitId:unitId,
            displayingCompanies:false,
            displayingUnits:false,
            displayingProjects:false,
            displayingEmployees:true,
            displayingGrouping:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false
        })
    }

    // This function to handle click events on the Clients tab
    companyTabItemOnClick = () =>{
        this.setState({
            unitId:"",
            companyType:this.state.companyType,
            showUnit: false,
            showEmployee:false,
            showProject:false,
            displayingCompanies:true,
            displayingUnits:false,
            displayingProjects:false,
            displayingGrouping:false,
            displayingEmployees:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false
        })
    } 

    // This function to handle click events on the Units tab
    unitTabItemOnClick = () =>{
        this.setState({
            unitId:"",
            displayingCompanies:false,
            displayingUnits:true,
            displayingProjects:false,
            displayingEmployees:false,
            displayingGrouping:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false
        })
    }

    projectTabItemOnClick = () => {
        this.setState({
            displayingCompanies:false,
            displayingUnits:false,
            displayingProjects:true,
            displayingEmployees:false,
            displayingGrouping:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false
        })
    }

    // This function to handle click events on the Grouping tab
    gropingTabItemOnClick = () =>{
        this.setState({
            displayingGrouping:true,
            displayingCompanies:false,
            displayingUnits:false,
            displayingProjects:false,
            displayingEmployees:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false

        })
    }

    // This function to handle click events on the City tab
    cityTabItemOnClick = () => {
        this.setState({
            displayingGrouping:false,
            displayingCompanies:false,
            displayingUnits:false,
            displayingProjects:false,
            displayingEmployees:false,
            displayingCities:true,
            displayingStates:false,
            displayingCountries:false
        })
    }

    // This function to handle click events on the State/Province tab
    stateTabItemOnClick = () => {
        this.setState({
            displayingGrouping:false,
            displayingCompanies:false,
            displayingUnits:false,
            displayingProjects:false,
            displayingEmployees:false,
            displayingCities:false,
            displayingStates:true,
            displayingCountries:false
        })
    }

    // This function to handle click events on the Country tab
    contryTabItemOnClick = () => {
        this.setState({
            displayingGrouping:false,
            displayingCompanies:false,
            displayingUnits:false,
            displayingProjects:false,
            displayingEmployees:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:true
        })
    }

    toggleCardsDisplay = () =>{
        this.setState({
            displayCards:!this.state.displayCards
        })
    }

    initData = () => {
        fetch(Constants.GetUserMenu,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                // let selectedAuditTypes = data.data.selectedAuditTypes;
                let isShowProject = false;
                let companyId = data.data.company.companyId
                let companyType = data.data.company.companyType
                let otherSettings = data.data.otherSettings ?? []
                let clientAuditType = data.data.clientAuditType;
                let clientId = data.data.user.clientId;
                isShowProject = clientAuditType?.some(item => item.clientId == clientId && item.auditType == "Project");

                let showCityMaster = otherSettings.some(item => 
                    item.settingColumn === "cityTransfer" && item.settingColumnEnabled === "Y")
                // if(!isEmptyVariable(selectedAuditTypes?.auditTypeList) &&
                // selectedAuditTypes.auditTypeList.includes("Project")){
                //     // showProject = true;
                //     showProject = false;
                // }

                this.setState({
                    selectedAuditTypes:data.data.selectedAuditTypes,
                    isShowProject:isShowProject,
                    companyId:companyId,
                    companyType:companyType,
                    showCityMaster:showCityMaster
                })
            }else{
                this.setState({
                    selectedAuditTypes:[],
                })
            }
        });
    }

    render() {
        return(
            <Router>
                <main className="main-dashboard">
                    <section className="dashboard-bg">
                        <Sidebar />

                        <div className="dashboard-right-bg position-relative">
                            <div className="dashboard-wrapper">
                                <Topbar />

                                <CompanyTabs 
                                    companyId = {this.state.companyId}
                                    unitId = {this.state.unitId}
                                    showUnit={this.state.showUnit}
                                    showEmployee={this.state.showEmployee}
                                    displayingCompanies = {this.state.displayingCompanies}
                                    displayingUnits = {this.state.displayingUnits}
                                    displayingProjects={this.state.displayingProjects}
                                    displayingEmployees = {this.state.displayingEmployees}
                                    displayingGrouping = {this.state.displayingGrouping}
                                    displayingCities={this.state.displayingCities}
                                    displayingStates={this.state.displayingStates}
                                    displayingCountries={this.state.displayingCountries}

                                    showCityMaster={this.state.showCityMaster}
                                    companyTabItemOnClick = {this.companyTabItemOnClick}
                                    unitTabItemOnClick = {this.unitTabItemOnClick}
                                    projectTabItemOnClick={this.projectTabItemOnClick}
                                    employeesTabItemOnClick = {this.employeesTabItemOnClick}
                                    gropingTabItemOnClick = {this.gropingTabItemOnClick}
                                    cityTabItemOnClick={this.cityTabItemOnClick}
                                    stateTabItemOnClick={this.stateTabItemOnClick}
                                    countryTabItemOnClick={this.contryTabItemOnClick}

                                    toggleCardsDisplay = {this.toggleCardsDisplay}
                                    showProject = {this.state.showProject}
                                    isShowProject={this.state.isShowProject}
                                    themeSettings = {themeSettings}
                                />

                                {
                                    this.state.displayingCompanies &&
                                    <ListCompanies 
                                        viewUnitsDropDownItemClick = {this.viewUnitsDropDownItemClick}
                                        viewProjectsDropDownItemClick = {this.viewProjectsDropDownItemClick}
                                        companyType={this.state.companyType}
                                        displayCards={this.state.displayCards}
                                        isShowProject={this.state.isShowProject}
                                        themeSettings = {themeSettings}
                                    />
                                }
                                {
                                    !isEmptyVariable(this.state.companyId) &&
                                    this.state.displayingUnits &&
                                    <ListUnits 
                                        companyId = {this.state.companyId}
                                        companyType={this.state.companyType}
                                        viewEmployeesDropDownItemClick = {this.viewEmployeesDropDownItemClick}
                                        viewProjectsDropDownItemClick = {this.viewProjectsDropDownItemClick}
                                        displayCards={this.state.displayCards}
                                        isShowProject={this.state.isShowProject}
                                        themeSettings = {themeSettings}
                                    />
                                }
                                {
                                    !isEmptyVariable(this.state.companyId) &&
                                    this.state.displayingProjects &&
                                    <ListProjects
                                        companyId = {this.state.companyId}
                                        displayCards={this.state.displayCards}
                                        themeSettings = {themeSettings}
                                    />
                                }
                                {
                                    !isEmptyVariable(this.state.unitId) &&
                                    this.state.displayingEmployees &&
                                    <Employees 
                                        unitId = {this.state.unitId}
                                        companyId={this.state.companyId}
                                        empHeaderText = {this.state.empHeaderText}
                                        displayCards={this.state.displayCards}
                                        themeSettings = {themeSettings}
                                    />
                                }
                                {
                                    this.state.displayingGrouping && 
                                    <Grouping />
                                }
                               {this.state.displayingCities &&
                                    <ListCities />
                               }
                               {this.state.displayingStates &&
                                    <ListStates />
                               }
                               {this.state.displayingCountries &&
                                    <ListCountries />
                                }
                            </div>
                        </div>
                    </section>
                </main>
            </Router>
        )
    }
}

export default ClientsMain;

